(function () {
  "use strict";

  var MQ_DESKTOP = window.matchMedia("(min-width: 990px)");

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function initAnimatedHero(section) {
    var imgWrapper = section.querySelector(".animated-hero__image-wrapper");
    if (!imgWrapper) return;
    var initialVisiblePercent = parseFloat(
      section.dataset.initialVisiblePercent,
    );
    var scrollSpeedMultiplier = parseFloat(
      section.dataset.scrollSpeedMultiplier,
    );
    var initialVisibleRatio = 0.4;

    var initialTranslate = 0;
    var finalTranslate = 0;
    var rafPending = false;

    if (isNaN(initialVisiblePercent)) {
      initialVisiblePercent = 40;
    }
    initialVisibleRatio = Math.max(0, Math.min(1, initialVisiblePercent / 100));

    if (isNaN(scrollSpeedMultiplier) || scrollSpeedMultiplier <= 0) {
      scrollSpeedMultiplier = 2;
    }

    function setup() {
      if (!MQ_DESKTOP.matches) {
        imgWrapper.style.transform = "";
        imgWrapper.style.willChange = "";
        return;
      }

      var imgH = imgWrapper.offsetHeight;
      var imgTop = imgWrapper.offsetTop;
      var viewH = window.innerHeight;

      // Start: only configured part of image visible at viewport bottom.
      initialTranslate = Math.max(
        0,
        viewH - imgH * initialVisibleRatio - imgTop,
      );
      // End: image bottom aligns exactly with viewport bottom (can be negative → shifts image up)
      finalTranslate = viewH - imgH - imgTop;

      imgWrapper.style.willChange = "transform";
      render();
    }

    function render() {
      if (!MQ_DESKTOP.matches) {
        imgWrapper.style.transform = "";
        return;
      }
      var scrollY = window.scrollY;
      var threshold = window.innerHeight * 0.5;
      // Higher multiplier = image enters faster for same scroll distance.
      var progress = easeOutCubic(
        Math.min(1, (scrollY * scrollSpeedMultiplier) / threshold),
      );
      var translate =
        initialTranslate + (finalTranslate - initialTranslate) * progress;
      imgWrapper.style.transform = "translateY(" + translate + "px)";
    }

    function onScroll() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        render();
        rafPending = false;
      });
    }

    // Recalculate after fonts / images have shifted layout
    window.addEventListener("load", setup);
    window.addEventListener("resize", setup, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });

    setup();
  }

  function init() {
    document.querySelectorAll(".animated-hero").forEach(initAnimatedHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
